import React, {Children} from "react";
import IconButton from "@material-ui/core/IconButton";

import useStyles from "./styles";

const Carousel = (props) => {

  const {
    children,
    delay
  } = props;

  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [paused, setPaused] = React.useState(false);
  const totalSlides = Children.count(children);
  const timeoutRef = React.useRef(null);

  React.useEffect(() => {
    if (paused || totalSlides <= 1) return;

    timeoutRef.current = setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, delay);

    return () => clearTimeout(timeoutRef.current);
  }, [currentIndex, paused, delay, totalSlides]);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div
      className={classes.sliderContainer}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div
        className={classes.sliderTrack}
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {Children.map(children, (child, index) => (
          <div
            className={classes.slide}
            key={index}
            style={{
              opacity: currentIndex === index ? 1 : 0,
              pointerEvents: currentIndex === index ? 'auto' : 'none',
            }}
          >
            {child}
          </div>
        ))}
      </div>

      {/* Dot Navigation */}
      {totalSlides > 1 && (
        <div className={classes.dotsContainer}>
          {Array.from({ length: totalSlides }).map((_, index) => (
            <IconButton
              key={index}
              onClick={() => handleDotClick(index)}
              style={{ fontSize: 10, width: 18, height: 18, padding: 4, color: currentIndex === index ? '#28B9D7' : '#CBD5E1' }}
            >
              <i className={'fa fa-circle'} />
            </IconButton>
          ))}
        </div>
      )}
    </div>
  )
};

Carousel.defaultProps = {
  delay: 5000
};

export default Carousel